import React from 'react'
import { BpmFormInput } from "components/FormModel/BpmFormInput";
import { BpmFormPicker } from "components/FormModel/BpmFormPicker";
import { BpmFormNationPicker } from "components/FormModel/BpmFormNationPicker";
import { BpmFormDataPicker } from "components/FormModel/BpmFormDataPicker";
import { BpmFormChoose } from "components/FormModel/BpmFormChoose";
import { BpmFormManyCascader } from "components/FormModel/BpmFormManyCascader";
import { BpmFormTextArea } from "components/FormModel/BpmFormTextArea";
import { BpmFormUpload } from "components/FormModel/BpmFormUpload";
import { BpmFormCascader } from "components/FormModel/BpmFormCascader";
import { BpmFormVerificationCode } from "components/FormModel/BpmFormVerificationCode";
// import {BpmFormCheckbox}from "components/FormModel/BpmFormCheckbox"
import { formType } from 'utils/constant';

const {INPUT,PICKER,NATIONPICKER,CHOOSE,DATEPICKER,MANYCASCADE,TEXTAREA,UPLOAD,CASCADER,VERIFICATIONCODE} = formType

/** 表单类型筛选 */
export function GetFormType(props) {
  const { item, item: { label, infoType } } = props
  /** 把所有参数传下去，各取所需 */
  const allProps = { key: label, item, ...props }

  /** 根据infotYPE渲染表单各字段 */
  function info_TYPE(infoType) {
    switch (infoType) {
      case INPUT:
        return (<BpmFormInput {...allProps} />);
      case PICKER:
        return (<BpmFormPicker {...allProps} />);
      case NATIONPICKER:
        return (<BpmFormNationPicker {...allProps} />);
      case CHOOSE:
        return (<BpmFormChoose {...allProps} />);
      case DATEPICKER:
        return (<BpmFormDataPicker {...allProps} />);
      case MANYCASCADE:
        return (<BpmFormManyCascader {...allProps} />);
      case TEXTAREA:
        return (<BpmFormTextArea {...allProps} />);
      case UPLOAD:
        return (<BpmFormUpload {...allProps} />);
      case CASCADER:
        return (<BpmFormCascader {...allProps} />);
      case VERIFICATIONCODE:
        return (<BpmFormVerificationCode {...allProps} />);
        // case CHECKBOX:
        //   return (<BpmFormCheckbox {...allProps} />);
      default:
    }
  }

  return info_TYPE(infoType)

}